import green from "@material-ui/core/colors/green"

const styles = (theme) => ({
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    overflow: "hidden",
  },
  wrapper: {
    position: "relative",
    display: "inline-block",
    color: "white",
  },
  wrapperFullWidth: {
    width: "100%",
  },
  promiseIconWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity .3s .3s ease-in-out",
  },
  promiseIcon: {
    color: "white",
    opacity: 0,
    marginTop: 15,
    transition: "opacity .3s .3s ease-in-out, margin-top .3s .3s ease-in-out",
  },
  get promiseSuccessIcon() {
    return {
      ...this.promiseIconWrapper,
      backgroundColor: theme.palette.success
        ? theme.palette.success.main
        : green["A400"],
    }
  },
  checkIcon: {
    width: 20,
  },
  get promiseErrorIcon() {
    return {
      ...this.promiseIconWrapper,
      backgroundColor: theme.palette.error.main,
    }
  },
  closeIcon: {
    width: 20,
  },
  showPromiseIcon: {
    opacity: 1,
    transition: "opacity .3s 0s ease-in-out",
    "& $promiseIcon": {
      opacity: 1,
      marginTop: 0,
      transition: "opacity .3s 0s ease-in-out, margin-top .3s 0s ease-in-out",
    },
  },
})

export default styles
